import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import * as moment from 'moment'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../../portalglobals'
import { OrganizationDataGateway } from '../../gatewasys/organization-data.gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { MyClientsCriteria } from '../../models/my-clients-criteria'
import { UserProfile } from '../../models/user-profile'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { EnrollmentCountModel } from '../../models/enrollment-count.model'
import { ExcelService } from '../../excel.service'
import * as _ from 'lodash'

@Component({
    selector: 'ss-my-clients',
    templateUrl: './ss-my-clients.component.html',
    styleUrls: ['./ss-my-clients.component.scss']
})
export class SsMyClientsComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('focusableEleTop', { static: true }) reportStart: ElementRef
    @ViewChildren('CountsGrid') countsGridChild: QueryList<jqxGridComponent>

    countsGrid: jqxGridComponent

    error: boolean = false
    errorMessage: string = ''
    myClientsCriteria: MyClientsCriteria
    myClientsCriteriaAU: MyClientsCriteria
    startdate: string
    endate: string
    userProfileDropdownValues: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    alternateUserProfiles: UserProfile[] = [] as UserProfile[]
    selectedUserProfile: UserProfile
    isAdmin: boolean
    isAetnaOrg: boolean
    rootOrgId: number
    currentUser: CurrentUser
    enrollmentCounts: EnrollmentCountModel[] = [] as EnrollmentCountModel[]
    loading: boolean
    selectedUser: number
    countsVisible: boolean
    width: number = 1040
    appStartDate: string
    appEndDate: string

    jqx: any
    source: any = {
        dataFields: [
            { name: 'PlanName', type: 'string' },
            { name: 'TierTranslation', type: 'string' },
            { name: 'Submitted', type: 'number' },
            { name: 'Enrolled', type: 'number' },
            { name: 'Disenrolled', type: 'number' },
            { name: 'Denied', type: 'number' },
            { name: 'Pending', type: 'number' },
            { name: 'Cancelled', type: 'number' },
            { name: 'CorrectionNeeded', type: 'number' }
        ],
        dataType: 'json',
        localData: this.enrollmentCounts
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    countRenderer = function (row, columnfield, value, id) {
        return '<div class="jqx-grid-cell-left-align"><a>' + value + '</a></div>'
    }

    columns: any[] = [
        { text: 'Plan Type', dataField: 'PlanName', width: 260 },
        {
            text: 'Submitted',
            dataField: 'Submitted',
            width: 110,
            cellsrenderer: this.countRenderer
        },
        { text: 'Enrolled', dataField: 'Enrolled', width: 100, cellsrenderer: this.countRenderer },
        { text: 'Disenrolled', dataField: 'Disenrolled', width: 115, cellsrenderer: this.countRenderer },
        { text: 'Denied', dataField: 'Denied', width: 90, cellsrenderer: this.countRenderer },
        { text: 'Pending', dataField: 'Pending', width: 90, cellsrenderer: this.countRenderer },
        { text: 'Cancelled', dataField: 'Cancelled', width: 105, cellsrenderer: this.countRenderer },
        { text: 'Correction Needed', dataField: 'CorrectionNeeded', width: 170, cellsrenderer: this.countRenderer }
    ]

    constructor(
        private routers: Router,
        private orgGateway: OrganizationDataGateway,
        private currentUserGateway: CurrentUserGateway,
        private reportsGateway: ReportsGateway,
        private excelService: ExcelService,
        private _globals: PortalGlobals
    ) {}

    ngOnInit() {
        this.myClientsCriteriaAU =
            localStorage.getItem('clientCriteriaAU') !== null ? JSON.parse(localStorage.getItem('clientCriteriaAU')!) : this.myClientsCriteria
    }

    ngAfterViewInit() {
        ;(<HTMLElement>document.getElementsByClassName('search-criteria')[0]).style.display = 'block'
        this.loading = true

        //this.countsGridChild.changes.subscribe((comp: jqxGridComponent) => {
        //    this.countsGrid = comp;
        //});

        this.myClientsCriteria = new MyClientsCriteria()
        this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
        this.myClientsCriteria.ApplicationEndDate = moment(this.endate).format('M/D/YYYY')
        this.appStartDate = '10/01/2005'
        this.appEndDate = moment(this.endate).format('M/D/YYYY')
        this.countsVisible = false
        this.selectedUserProfile = {} as UserProfile
        this.loadCurrentUser()
        this.countsGridChild.changes.subscribe((comp: QueryList<jqxGridComponent>) => {
            if (comp.length > 0) this.displayCountsData(comp.first)
        })
        //if (this.myClientsCriteriaAU !== undefined && this.myClientsCriteriaAU !== null) {
        //    this.appStartDate = this.myClientsCriteriaAU.ApplicationStartDate
        //    this.appEndDate = this.myClientsCriteriaAU.ApplicationEndDate
        //}
    }

    displayCountsData(comp: jqxGridComponent): void {
        this.countsGrid = comp
        if (this.enrollmentCounts !== null || this.enrollmentCounts !== undefined) {
            this.source.localdata = this.enrollmentCounts
            this.dataAdapter.dataBind()
            comp.updatebounddata()
            setTimeout(() => comp.focus(), 50)
        }
    }

    ngOnDestroy() {}

    onPageSizeChanged(event: any): void {
        let args = event.args
        this.source.pagesize = this.myClientsCriteria.PageSize = args.pagesize
        this.reportsGateway.getEnrollmentsCount(this.myClientsCriteria).subscribe((counts) => {
            this.source.localdate = counts
            this.dataAdapter.dataBind()
            this.countsGrid.updatebounddata()
        })
    }

    onExport() {
        let array = _.clone(this.enrollmentCounts)
        array.forEach(function (v) {
            delete v.PlanID
            delete v.TierTranslation
            delete v.Message
            delete v.StateAbbr
        })
        let strArray = JSON.stringify(array)
        strArray = strArray.replace(/PlanName/g, 'Plan Type')
        strArray = strArray.replace(/CorrectionNeeded/g, 'Correction Needed')
        let counts = JSON.parse(strArray)
        this.excelService.exportAsExcelFile(counts, 'My Clients Report')
    }

    onPrint() {
        let gridContent = this.countsGrid.exportdata('html')
        let newWindow = window.open('', '', 'width=800, height=500'),
            document = newWindow?.document.open(),
            pageContent =
                '<!DOCTYPE html>\n' +
                '<html>\n' +
                '<head>\n' +
                '<meta charset="utf-8" />\n' +
                '<title>Enrollment Counts</title>\n' +
                '</head>\n' +
                '<body>\n' +
                gridContent +
                '\n</body>\n</html>'
        document?.write(pageContent)
        document?.close()
        newWindow?.print()
    }

    Cellclick(event: any): void {
        if (event.args.datafield !== 'PlanName') {
            if (event.args.row.bounddata.PlanName === 'Totals') {
                this.myClientsCriteria.Plans = 'ALL'
            } else {
                this.myClientsCriteria.Plans = event.args.row.bounddata.TierTranslation
            }

            if (event.args.value > 0) {
                if (event.args.datafield === 'CorrectionNeeded') {
                    this.myClientsCriteria.ReportCategory = 'Correction Needed'
                } else {
                    this.myClientsCriteria.ReportCategory = event.args.datafield
                }
                localStorage.setItem('clientCriteriaAU', JSON.stringify(this.myClientsCriteria))
                this.reportsGateway.myClientsCriteriaAU = this.myClientsCriteria
                this.reportsGateway.selectedUserForSummaryReport = this.selectedUserProfile
                const insCo = this._globals.currentUser.insuranceCompanyShortName.toLowerCase()
                this.routers.navigateByUrl('/' + insCo + '/reports/ss-my-clients-summary')
            }
        }
    }

    onGetEnrollments() {
        if (this.selectedUser === null || this.selectedUser === undefined) {
            alert('Please select an user profile')
            return
        }

        this.alternateUserProfiles.forEach((up) => {
            if (up.UserProfileId == (this.selectedUser as number)) {
                this.selectedUserProfile = up
            }
        })

        if (this.selectedUserProfile !== undefined && this.selectedUserProfile !== null) {
            this.countsVisible = false
            this.getEnrollmentCounts()
        } else {
            alert('Error: Unable to locate userprofile record')
        }
    }

    initAlternateUserProfiles() {
        this.reportsGateway.getAlternateUserProfiles(this.currentUser.userProfileId).subscribe(
            (userProfiles: UserProfile[]) => {
                this.alternateUserProfiles = userProfiles
                userProfiles.forEach((up) => {
                    this.userProfileDropdownValues.push({
                        text: up.Fullname,
                        value: up.UserProfileId
                    })
                })
            },
            (error) => {
                console.log(error)
            }
        )
    }

    loadCurrentUser() {
        if (this._globals !== undefined && this._globals.currentUser !== undefined) {
            this.processCurrentUser(this._globals.currentUser)
        } else {
            this.currentUserGateway.getCurrentUser().subscribe(
                (user: CurrentUser) => {
                    this.processCurrentUser(user)
                },
                (error) => {
                    console.log(error)
                }
            )
        }
    }

    processCurrentUser(user: CurrentUser) {
        this.currentUser = user
        localStorage.setItem('reportuser', JSON.stringify(this.currentUser))
        if (this.currentUser != null && this.currentUser.orgId != null) {
            this.rootOrgId = parseInt(this.currentUser.orgId, 10)
            this.myClientsCriteria.InsuranceCompany = this.currentUser.insuranceCompanyName
            this.isAdmin = this.currentUser.IsAdmin
            this.isAetnaOrg = this.currentUser.AetnaInd
            if (this.isAdmin === false) {
                if (
                    this.currentUser.roleCode === 'Organization Manager' ||
                    this.currentUser.roleCode === 'Organization Admin' ||
                    this.currentUser.roleCode === 'Admin / Agent'
                ) {
                    this.isAdmin = true
                }
            }
            if (!this.isAdmin) {
                this.myClientsCriteria.AgentID = this.currentUser.userProfileName
            }
            this.myClientsCriteria.LoginProfileID = this.currentUser.userProfileId.toString()
            this.myClientsCriteria.OrgID = +this.currentUser.orgId
            if (
                this.myClientsCriteria.ApplicationStartDate === '' ||
                this.myClientsCriteria.ApplicationStartDate === undefined ||
                this.myClientsCriteria.ApplicationStartDate === null
            ) {
                this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
                this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
            }

            this.initAlternateUserProfiles()
        } else {
            console.log('current user is undefined')
        }
    }

    onInfoChange(fieldName: string, fieldValue: string): void {
        if (fieldName === 'ApplicationStartDate') this.appStartDate = fieldValue
        else if (fieldName === 'ApplicationEndDate') this.appEndDate = fieldValue

        this.myClientsCriteria[fieldName] = fieldValue
    }

    userProfileChanged(userProfileId: number) {
        this.selectedUser = userProfileId
        this.countsVisible = false
    }

    getEnrollmentCounts() {
        this.myClientsCriteria =
            localStorage.getItem('clientCriteriaAU') !== null ? JSON.parse(localStorage.getItem('clientCriteriaAU')!) : this.myClientsCriteria
        if (this.myClientsCriteria === undefined || this.myClientsCriteria === null || this.myClientsCriteria.OrgID === 0) {
            this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteriaAU')!)
        }

        if (this.myClientsCriteria === undefined || this.myClientsCriteria === null) {
            this.myClientsCriteria = new MyClientsCriteria()
        }

        this.myClientsCriteria.OrgID = this.selectedUserProfile.OrgId
        this.myClientsCriteria.LoginProfileID = this.selectedUserProfile.UserProfileId.toString()
        this.myClientsCriteria.AgentID = this.selectedUserProfile.UserProfileName
        this.myClientsCriteria.ApplicationStartDate = this.appStartDate
        this.myClientsCriteria.ApplicationEndDate = this.appEndDate
        //localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria));

        if (this.selectedUserProfile.AetnaInd === true) {
            this.reportsGateway.getPWEnrollmentsCountAU(this.myClientsCriteria).subscribe(
                (counts) => {
                    this.countsVisible = true
                    let eCount = new EnrollmentCountModel()
                    if (counts.length > 0 && counts[0].Message !== undefined && counts[0].Message !== '' && counts[0].Message !== null) {
                        eCount.Message = counts[0].Message
                    } else {
                        eCount.PlanName = 'Totals'
                        eCount.Cancelled = _.sumBy(counts, 'Cancelled')
                        eCount.CorrectionNeeded = _.sumBy(counts, 'CorrectionNeeded')
                        eCount.Denied = _.sumBy(counts, 'Denied')
                        eCount.Disenrolled = _.sumBy(counts, 'Disenrolled')
                        eCount.Enrolled = _.sumBy(counts, 'Enrolled')
                        eCount.Pending = _.sumBy(counts, 'Pending')
                        eCount.Submitted = _.sumBy(counts, 'Submitted')
                        counts.push(eCount)
                        this.enrollmentCounts = counts
                    }
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                    this.countsVisible = false
                    this.errorMessage = 'Failed to load the report'
                    this.reportStart.nativeElement.focus()
                }
            )
        } else {
            this.reportsGateway.getEnrollmentsCountAU(this.myClientsCriteria).subscribe(
                (counts) => {
                    this.countsVisible = true
                    let eCount = new EnrollmentCountModel()
                    if (counts.length > 0 && counts[0].Message !== undefined && counts[0].Message !== '' && counts[0].Message !== null) {
                        eCount.Message = counts[0].Message
                    } else {
                        eCount.PlanName = 'Totals'
                        eCount.Cancelled = _.sumBy(counts, 'Cancelled')
                        eCount.CorrectionNeeded = _.sumBy(counts, 'CorrectionNeeded')
                        eCount.Denied = _.sumBy(counts, 'Denied')
                        eCount.Disenrolled = _.sumBy(counts, 'Disenrolled')
                        eCount.Enrolled = _.sumBy(counts, 'Enrolled')
                        eCount.Pending = _.sumBy(counts, 'Pending')
                        eCount.Submitted = _.sumBy(counts, 'Submitted')
                        counts.push(eCount)
                        this.enrollmentCounts = counts
                    }
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                    this.countsVisible = false
                    this.errorMessage = 'Failed to load the report'
                    this.reportStart.nativeElement.focus()
                }
            )
        }
    }
}
